import React from "react";
import PreviewVideo from "./video-demo/previewVideo";
import { Link } from "gatsby";

export default ({ title, subtitle, data }) => {
  const featuredVideoTmpl = data.map(block => {
    return <PreviewVideo data={block} />;
  });
  return (
    <section className="white-section centered">
      <div className="container">
        <h2 className="h2">{title}</h2>
        <div className="md-spacing" />
        <p className="p center-align">{subtitle}</p>
        <div className="md-spacing" />
        <div className="grid-container-3">{featuredVideoTmpl}</div>
        <div className="sm-spacing" />
      </div>
      <Link to="/video-demos" className="link-text w-inline-block w-clearfix">
        <div className="learn-more">View More</div>
        <div className="arrow-right" />
      </Link>
    </section>
  );
};
